<mbs-table
  [headers]="headers"
  [loading]="loading()"
  [dataSourceData]="items()"
  (changeSelected)="changeSelected($event)"
  (selectAllOnAllPages)="selectAll($event)"
  [multipleSelect]="multipleSelect()"
  [showSelectAllCheckbox]="true"
  [showCheckboxes]="multipleSelect()"
  [showSelectAllHint]="multipleSelect()"
  [totalItems]="totalVisibleItems()"
  [totalSelectedItems]="totalSelectedItems()"
  [selectedCountText]="selectedCountText()"
  [selectable]="true"
  [virtualScrolling]="true"
  [virtualItemSize]="40"
  [minBufferPx]="200"
  [maxBufferPx]="2000"
  [keepState]="true"
  [myTrackBy]="trackBy"
  [maxHeight]="maxHeight()"
  [selectRowClass]="'-selected'">
  <ng-template
    mbsTableCell
    let-item>
    {{ item[bindLabel] }}
  </ng-template>
</mbs-table>
